import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type ResolvedEntry = {
  url: string;
  resolvedAt: number; // ms
  expiresAt: number; // ms
};

type MediaResolverState = {
  resolved: Record<string, ResolvedEntry>;
};

const initialState: MediaResolverState = {
  resolved: {},
};

const DEFAULT_TTL_SECONDS = Number(import.meta.env.VITE_MEDIA_PRESIGNED_TTL_SECONDS) || 14 * 60; // 14 minutes

const mediaResolverSlice = createSlice({
  name: 'mediaResolver',
  initialState,
  reducers: {
    setResolved: (
      state,
      action: PayloadAction<{ path: string; url: string; ttlSeconds?: number }>
    ) => {
      const now = Date.now();
      const ttl = (action.payload.ttlSeconds ?? DEFAULT_TTL_SECONDS) * 1000;
      state.resolved[action.payload.path] = {
        url: action.payload.url,
        resolvedAt: now,
        expiresAt: now + ttl,
      };
    },
    removeResolved: (state, action: PayloadAction<{ path: string }>) => {
      delete state.resolved[action.payload.path];
    },
    clearExpired: (state) => {
      const now = Date.now();
      Object.keys(state.resolved).forEach((k) => {
        if (state.resolved[k].expiresAt <= now) delete state.resolved[k];
      });
    },
  },
});

export const { setResolved, removeResolved, clearExpired } = mediaResolverSlice.actions;

export default mediaResolverSlice.reducer;
